import { useContext } from 'react';
import useCheckExperimentBucket from '~/hooks/useCheckExperimentBucket';
import { TileKitContext } from '../TileKit/TileKit';
import { InventoryTypeId } from '../TileKit/types';

export const useImageUrl = () => {
  const { vehicle, cdnUrl, vexUrl } = useContext(TileKitContext);
  const isHeroExperiment = useCheckExperimentBucket(
    'srch-standard-hero',
    'experiment'
  );

  if (!vehicle) {
    return '';
  }

  const hasJellyBeanUrl = Boolean(vehicle.jellyBeanMobileUrl);
  const hasStockNumber = Boolean(vehicle.stockNumber);
  const isWip = vehicle.vehicleInventoryType === InventoryTypeId.WIP;

  if (!hasStockNumber && !hasJellyBeanUrl) {
    return `${cdnUrl}/search-assets/noevox.png`;
  }

  return isWip
    ? vehicle.jellyBeanMobileUrl
    : `${vexUrl}${vehicle.stockNumber}/${
        isHeroExperiment ? 'standardizedHero' : 'hero'
      }.jpg`;
};

export const useAltText = () => {
  const { vehicle } = useContext(TileKitContext);
  const make = vehicle?.make;
  const model = vehicle?.model;
  const year = vehicle?.year;
  if (make && model && year) {
    return `${year} ${make} ${model}`;
  }

  return '';
};
